import { HouseIcon } from "lucide-react";
import React from "react";
import styled from "styled-components";
import { TaskGraph } from "src/types";
import { useBackButton } from "src/hooks/useBackButton";

interface Props {
  tasks: TaskGraph;
  breadcrumb: string[];
  setBreadcrumb(crumbs: string[]): void;
}

export function Breadcrumbs({ tasks, breadcrumb, setBreadcrumb }: Props) {
  const returnTo = (taskId: string) => {
    const idx = breadcrumb.indexOf(taskId);
    const breadcrumbs = breadcrumb.slice(0, idx + 1);
    setBreadcrumb(breadcrumbs);
  };

  const returnToHome = () => {
    setBreadcrumb([]);
  };

  const popBreadcrumb = React.useCallback(() => {
    const crumbs = breadcrumb.slice(0, breadcrumb.length - 1);
    setBreadcrumb(crumbs);
  }, [breadcrumb, setBreadcrumb]);

  useBackButton(breadcrumb.length > 0 ? popBreadcrumb : null);

  return (
    <Split data-testid="breadcrumbs">
      <Crumbs>
        <Crumb data-testid="breadcrumb-home" onClick={() => returnToHome()}>
          <HouseIcon size={12} />
        </Crumb>
        {breadcrumb.map((taskId) => {
          const task = tasks.tasks[taskId];
          if (!task) return null;
          return (
            <Crumb key={taskId} onClick={() => returnTo(taskId)}>
              {task.name}
            </Crumb>
          );
        })}
      </Crumbs>
    </Split>
  );
}

const Split = styled.div`
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 10px;
  background: var(--box-color-contrast);
`;

const Crumbs = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
`;

const Crumb = styled.div`
  display: flex;
  align-items: center;
  opacity: 0.5;
  font-size: 14px;
  cursor: pointer;
  &:last-child {
    opacity: 1;
    pointer-events: none;
    cursor: default;
  }
`;
